export default "__VITE_ASSET__V4L$t4EN__";